import { type GridColDef } from "@mui/x-data-grid";

import {
  ProductUpdate,
  ProductUpdateEditPayload,
  ProductUpdatePathParams,
  ProductUpdatePcm,
} from "api/memberPortal/product/productUpdate/productUpdate.types";

import { severityOptions } from "../updateForm/components/SeverityOption/data/severityOptions";

import ProductUpdateActionsCell from "./ProductUpdateActions.cell";

interface buildProductUpdateColumnsProps<
  T extends ProductUpdate | ProductUpdatePcm,
> {
  onArchive: (_payload: ProductUpdatePathParams) => void;
  onUnarchive: (_payload: ProductUpdateEditPayload) => void;
  getParentId: (_payload: T) => number;
}

export const buildProductUpdateColumns = <
  T extends ProductUpdate | ProductUpdatePcm,
>({
  onArchive,
  onUnarchive,
  getParentId,
}: buildProductUpdateColumnsProps<T>): GridColDef<T>[] => {
  return [
    {
      headerName: "Type",
      field: "severity",
      headerAlign: "center",
      renderCell: ({ row }) => <SeverityIcon severity={row.severity} />,
      align: "center",
      flex: 0,
      maxWidth: 75,
    },

    {
      headerName: "Update",
      field: "title",
      flex: 2,
    },

    {
      headerName: "Author",
      field: "author",
    },

    {
      headerName: "Issued On",
      field: "createdOn",
      type: "date",
      valueGetter: (value) => new Date(value),
      flex: 1,
    },

    {
      headerName: "Active",
      field: "active",
      type: "boolean",
    },

    {
      headerName: "",
      field: "actions",
      sortable: false,
      flex: 0,
      renderCell: ({ row }) => (
        <ProductUpdateActionsCell
          productUpdate={row}
          onArchive={onArchive}
          onUnarchive={onUnarchive}
          getParentId={getParentId}
        />
      ),
    },
  ];
};
interface SeverityIconProps {
  severity: number;
}

export const SeverityIcon = ({ severity }: SeverityIconProps) => {
  const { color, Icon } = severityOptions[severity];

  return <Icon color={color} fontSize="small" />;
};
